module.exports = __webpack_public_path__ + "static/media/cash-stack.33706b3d.svg";